import React from "react";
import { Footer } from "./Footer";
export function ParentComponentWithSideBar({ children, ...rest }) {
    return (
        <div className="col-md-12 no-padding">
            <div className="wrapper-div">
                {children}
            </div>
            {/*<Footer />*/}
        </div>
    )
}